import { Fragment } from 'react';
import Slider from '../../../../commons/components/Slider';
import { formatDateKorea } from '../../../../utils/helpers';
import Video from '../video';
import SkeletonLoadingComponent from '../../../../commons/components/SkeletonLoading';
import Loading from '../../../../commons/components/Loading';
import InfiniteScroll from 'react-infinite-scroll-component';

type props = {
  dataVideo: any,
  isProcessing: Boolean,
  params: Object,
  fetchMoreDataPaginate: Function,
  lastPage: Number,
  currentPage: Number,
  isProcessingDel: Boolean
};

const VideoTab = ({ dataVideo, isProcessing, params, fetchMoreDataPaginate, lastPage, currentPage, isProcessingDel }: props) => {

  const fetchMoreData = () => {
    let paramPage = {
      ...params,
      page: params.page + 1,
    }
    if (params.page < lastPage) {
      fetchMoreDataPaginate(paramPage);
    }
  }

  const loadingDiv = <div className='pt-3 pl-3 pr-3'>
    <SkeletonLoadingComponent width={100} />
    <SkeletonLoadingComponent type={'video'} height={183}/>
  </div>

  return (
    <>
        {(isProcessing && lastPage <= 1) || isProcessingDel ? (
          loadingDiv
        ) : !dataVideo || Object.keys(dataVideo).length <= 0 ? (
          <div className="container mt-5 pt-5">
            <div className="row pt-5">
              <div className="col-12">
                <p className="text-center p-0 m-0">해당하는 데이터가 없습니다</p>
              </div>
            </div>
          </div>
        ) :(
          <InfiniteScroll
            dataLength={Object.keys(dataVideo).length}
            next={fetchMoreData}
            hasMore={currentPage < lastPage ? true : false}
            loader={loadingDiv}
            >
              {
                 (
                  Object.keys(dataVideo).map((day) => (
                    <Fragment key={day}>
                      <p className="tabs__content__section__time ml-3 mb-2 mt-3">
                        {formatDateKorea(day)}
                      </p>
                      {/* <Slider
                        pagination={false}
                        classSlider="swiper-pagination__custom "
                        slidesPerView={1}
                        classSwiper={`swiper-video-custom`}
                      > */}
                        {(dataVideo[day] ?? []).map((item, key) => (
                          <Video
                            key={key}
                            videoDetail={item}
                            handleDetailVideo={() => handleDetailVideo(item?.id)}
                            isProcessing={isProcessing}
                            publishStatus={true}
                            params={params}
                          />
                        ))}
                      {/* </Slider> */}
                    </Fragment>
                  ))
                )
              }
          </InfiniteScroll>
        )}
    </>
  );
};

export default VideoTab;
